'use strict';
import * as T from 'prop-types';
import isUndefined from 'lodash/isUndefined';

import * as LOADING_STATES from '../../core-components/loading-icon/loading-states';

export const ViewMode = {
  /** @type {ViewMode} */
  LOADING: 'loading',
  /** @type {ViewMode} */
  LOADING_MORE: 'loading_more',
  /** @type {ViewMode} */
  SUCCESS: 'success',
  /** @type {ViewMode} */
  NO_DATA: 'NO_DATA',
  /** @type {ViewMode} */
  EOTHER: 'error',
  /** @type {ViewMode} */
  ENONET: 'no_network',
};

// Create the prop type before adding static methods
export const ViewModePropType = T.oneOf(Object.values(ViewMode));

/**
 * @param {LOADING_STATES} value
 * @return {ViewMode}
 */
ViewMode.fromLoadingState = value => {
  switch (value) {
    case LOADING_STATES.LOADED:
      return ViewMode.SUCCESS;
    case LOADING_STATES.PLACEHOLDER:
    case LOADING_STATES.NO_DATA:
      return ViewMode.NO_DATA;
    case LOADING_STATES.NO_NETWORK:
      return ViewMode.ENONET;
    case LOADING_STATES.LOADING:
    default:
      return ViewMode.LOADING;
  }
};

ViewMode._isOnline = () => {
  return isUndefined(navigator.onLine)
    ? true /* no way to know */
    : navigator.onLine;
};

/**
 * @return {ViewMode}
 */
ViewMode.getErrorMode = () => {
  return ViewMode._isOnline() ? ViewMode.EOTHER : ViewMode.ENONET;
};

/**
 * @typedef {String} ViewMode
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/enums/ViewMode.js